import styled from 'styled-components';
import {breakPoint} from './var';


export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: ${breakPoint.min}) 
    
    
    max-width: 120rem;
  }
`;

export const GridStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  @media (min-width: ${breakPoint.min}) {
    > div {
      flex: 1 1 25%;
      max-width: calc(25% - 15px);
    }
  }
  @media (max-width: ${breakPoint.max}) {
    gap: 1rem;
    > div {
      flex: 1 1 50%;
      max-width: calc(50% - 15px);
    }
  }
`;
